import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg leading-7 font-medium text-black pb-6" }, "Add a delay between actions. Select a delay type:", -1)
const _hoisted_3 = { class: "flex flex-col gap-y-3" }

import { Component } from "vue"
import { ClockIcon } from "@heroicons/vue/outline"
import CalendarDateComponent from "@/components/workflows/sidebar/action/delay/CalendarDateComponent.vue"
import DatePropertyComponent from "@/components/workflows/sidebar/action/delay/DatePropertyComponent.vue"
import TimeAmountComponent from "@/components/workflows/sidebar/action/delay/TimeAmountComponent.vue"
import WeekDaysComponent from "@/components/workflows/sidebar/action/delay/WeekDaysComponent.vue"
import TimeOfDayComponent from "@/components/workflows/sidebar/action/delay/TimeOfDayComponent.vue"
import DelayTypeCard from "@/components/workflows/sidebar/action/delay/DelayTypeCard.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'DelaySidebarComponent',
  emits: ["changeAction"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const delayTypes = [
    { title: "Calendar date", example: "Delay until 03/21/2023 at 12:00 PM", component: CalendarDateComponent },
    { title: "Date property", example: "Delay until contact's Last activity date", component: DatePropertyComponent },
    { title: "Set amount of time", example: "Delay for 3 days and 4 hours", component: TimeAmountComponent },
    { title: "Days of week", example: "Delay until Monday", component: WeekDaysComponent },
    { title: "Time of day", example: "Delay until 12:00 PM EST", component: TimeOfDayComponent },
    {
        title: "Event occurrence",
        example: "Delay until a contact visits your website",
        component: CalendarDateComponent,
    },
]

function selectDelayType(sidebarComponent: Component) {
    emit("changeAction", {
        icon: ClockIcon,
        title: "Configure delay...",
        sidebarComponent,
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(delayTypes, (delay) => {
        return _createVNode(DelayTypeCard, {
          key: delay.title,
          title: delay.title,
          example: delay.example,
          onClick: ($event: any) => (selectDelayType(delay.component))
        }, null, 8, ["title", "example", "onClick"])
      }), 64))
    ])
  ]))
}
}

})